export const CaseHero = ({ campaign: c, index }) => {
  return (
    <header className="pt-28 md:pt-36 pb-12 md:pb-16 hairline-b border-b">
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 grid grid-cols-12 gap-6 text-[10.5px] tracking-[0.22em] uppercase font-medium pb-8 md:pb-12">
        <div className="col-span-6 md:col-span-3">
          <div className="opacity-50 mb-1">Brand</div>
          <div>{c.brand}</div>
        </div>
        <div className="col-span-6 md:col-span-3">
          <div className="opacity-50 mb-1">When</div>
          <div>{c.year}</div>
        </div>
        <div className="hidden md:block md:col-span-3">
          <div className="opacity-50 mb-1">Case</div>
          <div>№{String(index + 1).padStart(2, "0")}</div>
        </div>
        <div className="hidden md:block md:col-span-3">
          <div className="opacity-50 mb-1">Lead</div>
          <div>Yash Kankaria</div>
        </div>
      </div>

      <div className="max-w-[1480px] mx-auto px-5 md:px-10">
        <h1
          data-testid="case-title"
          className="text-[clamp(2.5rem,8vw,8rem)] font-black tracking-[-0.04em] leading-[0.92] mb-6 md:mb-10"
        >
          {c.title}
          <span className="text-[var(--accent)]">.</span>
        </h1>
        <p className="text-xl md:text-3xl font-medium tracking-tight leading-snug max-w-4xl">
          &ldquo;{c.tagline}&rdquo;
        </p>
      </div>
    </header>
  );
};
